// Default colors
export const defaultColors = {
    light: {
        primary: '#403ddb',
        onPrimary: '#ffffff',
        secondary: '#04d5a9',
        onSecondary: '#000000',
        background: '#f5f5f5',
        paper: '#ffffff',
        text: '#333333',
    },
    dark: {
        primary: '#6561e3',
        onPrimary: '#ffffff',
        secondary: '#03a085',
        onSecondary: '#ffffff',
        background: '#1e1e1e', // VS Code-ähnlicher Hintergrund
        paper: '#2d2d30', // Hellere Kartenfarbe für besseren Kontrast
        text: '#ffffff',
    },
};
